<template>
	<div>
		<el-button style="margin-bottom: 20px;" type="primary" @click="setsu('null')">添加通知</el-button>
		<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border stripe
			@selection-change="handleSelectionChange">
			<el-table-column label="通知内容" align="center" prop="name"></el-table-column>
			<el-table-column label="排序" align="center" prop="sort"></el-table-column>
			<el-table-column label="操作" align="center" prop="icon" fixed="right">
				<template slot-scope="scope">
					<el-button type="primary" plain v-if="scope.row.state==0" @click="getTypeButton(scope.row)">启用</el-button>
					<el-button type="danger" plain v-if="scope.row.state==1" @click="getTypeButton(scope.row)">禁用</el-button>
					<el-button type="primary" plain @click="UpdateConfigTypeButton(scope.row)">编辑</el-button>
					<el-popconfirm title="确定删除该轮播吗？" @confirm="delHandle(scope.row.id)">
						<el-button type="danger" plain slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="current"
			:page-size="size" :total="total">
		</el-pagination>
		<el-dialog title="轮播" :visible.sync="dialogVisible" width="800px" append-to-body :before-close="handleClose">
			<el-form :model="editForm" ref="editForm" label-width="100px" class="demo-editForm">
				<el-form-item label-width="100px" label="通知内容"> <el-input v-model="name"></el-input> </el-form-item>
				<el-form-item label-width="100px" label="排序"> <el-input v-model="sort" type="number"></el-input> </el-form-item>
				
				<el-form-item> <el-button type="primary" @click="submitForm()">完成</el-button> </el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script>
	import VploadImg from "../inc/VploadImgTwo";
	export default {
		name: "ConfigType",
		components: {
			VploadImg
		},
		data() {
			return {
				searchForm: {},
				shopForm: {},
				delBtlStatu: true,
				tableData: [],
				
				shopData: [],
				multipleSelection: [],
				filesd: [],
				editForm: {},
				total: 0,
				size: 10,
				current: 1,
				dialogVisible: false,
				crileVisible: false,
				shopVisible: false,
				articleId: '',
				image: "",
				jumpPath: "",
				jumpType: '1',
				name: "",
				sort: 0,
				storeGoodsId: '',
				type: 0,
				id: '',
				inforlist: [],
				typeList: [],
				articleClassId: '',
				title: '',
				criletit: '',
				shoptit: '',
			}
		},
		created() {
			this.getConfigType();
			this.getInfor()
			this.getTypeList()
		},
		methods: {
			getTypeButton(e){
				this.$axios.post("/admin/carousel/modifyState", {
					id: e.id
				}).then(res => {
					this.getConfigType()
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose: () => {
							
						}
					});
				})
			},
			delHandle(id) {
				this.$axios.post("/admin/carousel/del", {
					id: id
				}).then(res => {
					this.getConfigType()
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose: () => {
							
						}
					});
				})
			},
			chooseshop(e) {
				if (this.storeGoodsId == e.storeGoodsId) {
					this.storeGoodsId = ''
					this.shoptit = ''
				} else {
					this.storeGoodsId = e.storeGoodsId
					this.shoptit = e.storeGoodsName
				}
				this.shopVisible = false
			},
			getTypeList() {
				this.$axios.post("/admin/singleStoreGoods/getTypeList", ).then(res => {
					this.typeList = res.data;
				})
			},
			choose(e) {
				if (this.articleId == e.id) {
					this.articleId = ''
					this.criletit = ''
				} else {
					this.articleId = e.id
					this.criletit = e.title
				}
				this.crileVisible = false
			},

			getInfor() {
				this.$axios.post("/admin/article/classificationList", {}).then(res => {
					this.inforlist = res.data
				})
			},
			getmass() {
				this.currents = 1
				this.getInformations()
			},
			setcrile() {
				this.crileVisible = true
				this.getInformations()
			},
			setsu() {
				this.id = ''
				this.name = ''
				this.dialogVisible = true
			},
			getImg(url, add) {
				if (add == 1) {
					this.image = url
				} else if (add == 0) {
					this.image = ''
				}
			},
			
			handleClose() {
				this.dialogVisible = false
			},
			handlecrile() {
				this.crileVisible = false
				this.shopVisible = false
			},
			
			
			submitForm() {
				
				if (this.id) {
					this.$axios.post("/admin/carousel/edit", {
						jumpType: 4,
						name: this.name,
						sort: this.sort,
						type: 2,
						id: this.id
					}).then(res => {
						this.dialogVisible = false
						this.getConfigType()
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
							onClose: () => {

							},
						})
					})
				} else {
					this.$axios.post("/admin/carousel/add", {
						jumpType: 4,
						name: this.name,
						sort: this.sort,
						type: 2,

					}).then(res => {
						this.dialogVisible = false
						this.getConfigType()
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
							onClose: () => {

							},
						})
					})
				}

			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				this.delBtlStatu = val.length == 0
			},

			handleSizeChange(val) {
				this.size = val
				this.getConfigType()
			},
			handleCurrentChange(val) {
				this.current = val
				this.getConfigType()
			},
			
			//获取常量数据配置列表
			getConfigType() {
				this.searchForm.pageNo = this.current
				this.searchForm.pageSize = this.size
				this.searchForm.type = 2
				this.$axios.post("/admin/carousel/getList", this.searchForm).then(res => {
					this.tableData = res.data.records
					this.current = res.data.current
					this.total = res.data.total
					this.size = res.data.size
				})
			},
			UpdateConfigTypeButton(id) {
				this.id = id.id
				this.sort= id.sort
				this.name = id.name
				this.dialogVisible = true
			},
		}
	}
</script>

<style scoped>
	.el-button {
		padding: 0 10px;
		height: 35px;
		line-height: 35px;
		font-size: 15px;
		margin-right: 10px;
	}
</style>